// extracted by mini-css-extract-plugin
module.exports = {"ldsSpinner":"Placeholder-module-ldsSpinner--h3xGm","lds-spinner":"Placeholder-module-lds-spinner--vHI1X"};